import { render, staticRenderFns } from "./TableEditorDialog.vue?vue&type=template&id=72b30496&"
import script from "./TableEditorDialog.vue?vue&type=script&lang=js&"
export * from "./TableEditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports